import { Tag, Col, Panel, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';

const { Cell } = Table;

export default function StyledCell ({ rowData, dataKey, ...props }) {
    return (
        <Cell {...props} style={{borderBottom: "0.25rem var(--rs-gray-200) solid !important"}}>
            {rowData[dataKey]}
        </Cell>
    );
};